import React, { useState } from 'react';
import { Icon } from '@pwc/pwc-deals-ui';
import { Link } from 'react-router-dom';
import { CommentTarget, USER_ROLES } from '@pwc/pwc-deals-web-common';

import { useSelector } from 'react-redux';
import { getUserRole } from 'common/redux/security/loggedInUser/loggedInUserSlice';

import FieldCommentWrapper from 'common/components/FieldCommentWrapper';
import { getViewPathForAnalysis } from '../../../features/analyses/common/analysisUrlHelper';
import '../Accordion/Accordion.scss';
import './LinkedContentNavigation.scss';

const LinkedConnectionsAccordion = ({
  allConnections = [],
  title,
  projectId,
  onExpand,
  onClose,
  width = 21,
  currentContent,
}) => {
  const isPwcUser = useSelector(getUserRole) === USER_ROLES.PWC_USER;

  const [isOpen, setIsOpen] = useState(false);

  const handleOnClick = () => {
    if (!isOpen && typeof onExpand === 'function') {
      onExpand();
    }
    if (onClose) {
      onClose();
    }

    setIsOpen(!isOpen);
  };

  const markAsGrey = (connectionContent) => {
    if (connectionContent) {
      if (connectionContent.contentId === currentContent.contentId) {
        return true;
      }
    }

    return false;
  };

  return (
    <>
      {isOpen &&
        allConnections.map((analysis, index) => (
          <div className="connected-analyses-item">
            <FieldCommentWrapper fieldKey={CommentTarget.ConnectedAnalyses}>
              {markAsGrey(analysis) ? (
                <div className="connected-analyses__first">
                  {analysis.title}
                </div>
              ) : (
                <Link
                  to={getViewPathForAnalysis(
                    projectId,
                    analysis,
                    false,
                    isPwcUser
                  )}
                  key={analysis.contentId}
                  data-testid={`navigation-connected-content-${index}`}
                  className="connected-analyses__list__link"
                >
                  {analysis.title}
                </Link>
              )}
            </FieldCommentWrapper>
          </div>
        ))}
      <button
        type="button"
        onClick={handleOnClick}
        className="accordion-toggle"
        data-testid="accordion-toggle"
      >
        {title}
        <Icon
          name={isOpen ? 'desc' : 'asc'}
          width={width}
          className="fill icon-orange-theme accordion-icon"
        />
      </button>
    </>
  );
};

export default LinkedConnectionsAccordion;
